// ============================================
// Leka — i18n (lightweight, global state via Zustand)
// ja → Japanese, everything else → English
// ============================================
import { create } from 'zustand'

const translations = {
  en: {
    // WorldHome
    heroTitle: 'Five public surfaces.\nOne engine,\nreal follow-through.',
    season1: 'Season 1',
    aiPersonsCount: (n: number) => `${n} surfaces`,
    signIn: 'Sign in',
    heroSub: '',
    footerDisclaimer: 'Leka surfaces · All characters are fictional',
    meetThem: 'Meet them',
    footerCta: 'Ready to see the five public surfaces?',

    // CharProfile
    online: 'Available',
    offline: 'Unavailable',
    videoCall: 'Talk',
    messageOnTelegram: 'Message on Telegram',
    chatOnLine: 'Chat on LINE',
    opening: 'Opening…',
    comingSoon: 'Coming soon',
    back: 'Back',
  },
  ja: {
    heroTitle: '5つのsurface。\n1つのengineで、\nちゃんと前に進む。',
    season1: 'Season 1',
    aiPersonsCount: (n: number) => `${n}つのsurface`,
    signIn: 'ログイン',
    heroSub: '',
    footerDisclaimer: 'Leka surfaces · 全キャラクターは架空です',
    meetThem: '会いに行く',
    footerCta: '5つのsurfaceを見てみる？',

    online: '対応可能',
    offline: '準備中',
    videoCall: '話す',
    messageOnTelegram: 'Telegramでメッセージ',
    chatOnLine: 'LINEでチャット',
    opening: '接続中…',
    comingSoon: '近日公開',
    back: '戻る',
  },
} as const

export type Locale = 'en' | 'ja'

export function detectLocale(): Locale {
  if (typeof navigator === 'undefined') return 'en'
  return navigator.language.startsWith('ja') ? 'ja' : 'en'
}

// ── Global locale store ──
interface LocaleStore {
  locale: Locale
  setLocale: (l: Locale) => void
  toggleLocale: () => void
}

export const useLocaleStore = create<LocaleStore>((set, get) => ({
  locale: detectLocale(),
  setLocale: (locale) => set({ locale }),
  toggleLocale: () => set({ locale: get().locale === 'ja' ? 'en' : 'ja' }),
}))

export function t<K extends keyof typeof translations.en>(key: K, locale?: Locale): (typeof translations.en)[K] {
  const l = locale ?? useLocaleStore.getState().locale
  return (translations[l] as typeof translations.en)[key]
}
